import { snakeCase } from 'change-case';

export const convertObjectKeysToSnakeCase = (
  object: Record<string, unknown>,
): Record<string, unknown> =>
  Object.keys(object).reduce(
    (newObject, key) => ({ ...newObject, [snakeCase(key)]: object[key] }),
    {},
  );
